<template>
  <div class="headerInfo">
    <div class="week">
      {{week_info.week_text || ''}}·{{week_info.knowledge || ''}}·第{{timesCN}}次作业
    </div>
    <div class="questionId">题目 ID：{{question_list[index].no}}</div>
  </div>
</template>

<script>
export default {
  name: 'headerInfo',
  props: {
    question_list: {
      type: Array,
    },
    week_info: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
    timesCN: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
  .headerInfo {
    width: 100%;
    height: halvePx(80);
    background: rgba(244, 229, 194, 1);
    display: flex;
    align-items: center;
    line-height:halvePx(80);
    padding:halvePx(40);
    .week {
      font-size: halvePx(28);
      font-family: PingFang-SC-Regular;
      // font-weight: 400;
    }
    .questionId {
      flex:1;
      text-align: right;
      font-size: halvePx(28);
      font-family: PingFang-SC-Regular;
      // font-weight: 500;
    }
  }
</style>
